<template>
  <layout-with-sidebar>

    <HeaderComponent/>


    <div class=" ed-bg text-color">
      <br>
      <h1 class="h3 mb-3 font-weight-normal text-color text-center">Impostazione di stampa</h1>
      <br>


      <div class="container text-left">

        <div class="row">
          <div class="col col-12">
            <h4>La tua stampante:</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <label>Marca</label>
            <input type="text" class="form-control" v-model="user_form.printer_brand"
                   placeholder="Es.:Xerox, Samsung, HP...">
          </div>
          <div class="col col-12 col-md-6">
            <label>Modello</label>
            <input type="text" class="form-control" v-model="user_form.printer_model" placeholder="Es.:XP1522, HP10NJ">
          </div>
        </div>

        <br>

      </div>

      <br>


      <div class="container text-left">

        <h4>Seleziona Template PDF:</h4>
        <select class="form-control" v-model="selected_template">
          <option value="centro_destra">Centro Destra</option>
          <option value="centro_sinistra">Centro Sinistra</option>
          <option value="basso_destra">Basso Destra</option>
          <option value="basso_sinistra">Basso Sinistra</option>
          <option value="alto_destra">Alto Destra</option>
          <option value="alto_sinistra">Alto Sinistra</option>
        </select>
        <br>

        <div class="row">
          <div class="col-6">
            <img src="/images/template-pdf_alto-destra.png" width="200"
                 v-if="selected_template==='alto_destra'">
            <img src="/images/template-pdf_alto-sinistra.png" width="200"
                 v-if="selected_template==='alto_sinistra'">
            <img src="/images/template-pdf_basso-destra.png" width="200"
                 v-if="selected_template==='basso_destra'">
            <img src="/images/template-pdf_basso-sinistra.png" width="200"
                 v-if="selected_template==='basso_sinistra'">
            <img src="/images/template-pdf_centro-destra.png" width="200"
                 v-if="selected_template==='centro_destra'">
            <img src="/images/template-pdf_centro-sinistra.png" width="200"
                 v-if="selected_template==='centro_sinistra'">

          </div>
          <div class="col-6">
            Per una ottimale Stampa segui i seguenti consigli:<br>
            - Utilizza Chrome come browser<br>
            - Una volta scaricato il file pdf da stampare
            aprilo direttamente in Chrome;
            <br><br>
            Scegli le seguenti configurazioni di stampa su Chrome:<br>
            - Formato carta: A4<br>
            - Scala: Adatta ad area stampabile<br>
          </div>
        </div>


      </div>

      <br>


      <!-- <b-form class=" custom-centered" > -->
      <br><br> <br>
      <div class="container text-left">
        <h3>Impostazioni di tutta la cambiale
        </h3>
        <br>
        <div class="row">
          <div class="col col-12">
            <h4>Dimensioni Testo </h4>
            <label><strong>Aumenta</strong> o Diminuisci il font di tutti i campi della cambiale (predefinito 3.6
              mm)</label>

            <div class="input-group mb-3">

              <input v-model="user_form.text_size" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

          </div>


        </div>

        <div class="row">
          <div class="col col-12">
            <h4>Dimensioni Testo Blocco Firma</h4>
            <label><strong>Aumenta</strong> o Diminuisci il font di tutti i campi del blocco firma (predefinito 3.6
              mm)</label>

            <div class="input-group mb-3">

              <input v-model="user_form.text_size_signature" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

          </div>

        </div>

        <div class="row">
          <div class="col-12" v-show="selected_template=='centro_destra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Centro/Destra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 51.6
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.center_right_top" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0.5
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.center_right_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>


            <br>


            <h3>DEBITORE Blocco
            </h3>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.debtor_top_center_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 80.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.debtor_right_center_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE Blocco
            </h3>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_center_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 2.65
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_center_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>

            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 15.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_center_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 175.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_center_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


          </div>


          <div class="col-12" v-show="selected_template=='centro_sinistra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Centro/Sinistra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 52.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.center_left_top" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 0 mm)</label>

            <div class="input-group mb-3">

              <input v-model="user_form.center_left_left" type="number"
                     class="form-control"
                     placeholder="da <strong>sinistra</strong>">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE BLOCCO - Posizione di stampa</h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_center_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_center_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 11.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_center_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 179
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_center_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>
          </div>


          <div class="col-12" v-show="selected_template=='basso_sinistra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Basso/Sinistra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 109.6
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.bottom_left_top" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.bottom_left_left" type="number"
                     class="form-control"
                     placeholder="da <strong>sinistra</strong>">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE BLOCCO - Posizione di stampa</h3>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_bottom_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_bottom_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 11.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_bottom_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label>margine da destra (predefinito 179.0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_bottom_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


          </div>


          <div class="col-12" v-show="selected_template=='basso_destra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Basso/Destra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 109.6
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.bottom_right_top" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.bottom_right_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE BLOCCO - Posizione di stampa</h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_bottom_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_bottom_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>
            <br>

            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 11.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_bottom_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 179.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_bottom_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


          </div>


          <div class="col-12" v-show="selected_template=='alto_sinistra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Alto/Sinistra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_left_top" type="number" class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_left_left" type="number" class="form-control"
                     placeholder="da <strong>sinistra</strong>">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE BLOCCO - Posizione di stampa</h3>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_top_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_top_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>

            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 11.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_top_left" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 179.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_top_left" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


          </div>


          <div class="col-12" v-show="selected_template=='alto_destra'">
            <h4>TUTTA LA CAMBIALE - Orientamento Alto/Destra </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 0 mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_right_top" type="number" class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_right_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


            <h3>DOMICILIAZIONE BLOCCO - Posizione di stampa</h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 62.0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_top_top_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 0
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.domiciliation_right_top_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>

            <h3>IMPORTO IN CIFRE - Posizione di stampa
            </h3>

            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 11.0
              mm)</label>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Diminuisci per spostare in <strong>alto</strong></label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_top_top_right" type="number"
                     class="form-control"
                     placeholder="dall'alto">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label> <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 179
              mm)</label>
            <div class="input-group mb-3">

              <input v-model="user_form.amount_right_top_right" type="number"
                     class="form-control"
                     placeholder="da destra">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>

            <br>


          </div>


        </div>

        <div class="row">
          <div class="col-12"><br><br>
            <h3>Impostazione Singoli elementi</h3><br><br>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h4>CODICE PRATICA - Posizione di stampa </h4>
            <label> <i class="fas fa-info-circle"></i>
              Nota: Posizione della stampa del campo codice Pratica</label>
            <div class="input-group mb-3">

              <select v-model="user_form.amortization_code_position" class="form-control">
                <option value="ALTO_SINISTRA">Alto Sinistra</option>
                <option value="ALTO_DESTRA">Alto Destra</option>
                <option value="NON_VISUALIZZA">Non Visualizzato</option>
              </select>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h4>DATA EMISSIONE - Visualizzazione </h4>
            <div class="input-group mb-3">

              <select v-model="user_form.amortization_date_issue" class="form-control">
                <option value="VISUALIZZA">Visualizzata in stampa</option>
                <option value="NON_VISUALIZZA">Non Visualizzata in stampa</option>
              </select>

            </div>
          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">

            <h4>LUOGO EMISSIONE e DATA EMISSIONE Pratica - Posizione di stampa</h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 12.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>

            <div class="input-group mb-3">

              <input v-model="user_form.top_date_place_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


          </div>
        </div>

        <!--
                <div class="row mt-4">
                  <div class="col-12">
                    <h4>IMPORTO IN CIFRE - Posizione di stampa </h4>
                    <label class="w-100">
                      <i class="fas fa-info-circle"></i>
                      Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong>
                    </label>
                    <label class="w-100">
                      <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
                    </label>
                    <div class="input-group mb-3">

                      <input v-model="user_form.top_amount_position" type="number" class="form-control">
                      <div class="input-group-append">
                        <span class="input-group-text">mm</span>
                      </div>

                    </div>
                  </div>
                </div> -->


        <div class="row mt-4">
          <div class="col col-12">
            <h4>SCADENZA - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 24.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_expire_date_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>


        </div>


        <div class="row mt-4">
          <div class="col col-12">
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: Scegli se visualizzare oppure no la data di scadenza nella cambiale
            </label>
            <div class="input-group mb-3">

              <select v-model="user_form.amortization_expire_date" class="form-control">
                <option value="VISUALIZZA">Visualizzata in stampa</option>
                <option value="NON_VISUALIZZA">Non Visualizzata in stampa</option>
              </select>

            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <h4>TIPO CAMBIALE - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 24.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_amortization_type_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 151.6mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare a <strong>sinistra</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.right_amortization_type_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>


          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <h4>BENEFICIARIO - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 38.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_beneficiary_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">
            <h4>IMPORTO IN LETTERE - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 49.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_amount_letter_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>
        <!--

                <div class="row mt-4">
                  <div class="col-12">
                    <h4>DOMICILIAZIONE - Posizione di stampa </h4>
                    <label class="w-100">
                      <i class="fas fa-info-circle"></i>
                      Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong>
                    </label>
                    <label class="w-100">
                      <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
                    </label>
                    <div class="input-group mb-3">

                      <input v-model="user_form.top_domiciliazione_position" type="number" class="form-control">
                      <div class="input-group-append">
                        <span class="input-group-text">mm</span>
                      </div>

                    </div>
                  </div>
                </div> -->

        <div class="row mt-4">
          <div class="col-12">
            <h4>DOMICILIAZIONE CAB - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>destra</strong> (predefinito 23.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare a <strong>sinistra</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.right_cab_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">
            <h4>DEBITORE PROV. - Posizione di stampa </h4>

            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 83.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">
              <input v-model="user_form.top_debtor_province_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>


            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare a <strong>sinistra</strong> (predefinito 147.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare a <strong>destra</strong>
            </label>
            <div class="input-group mb-3">
              <input v-model="user_form.right_debtor_province_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>
            </div>


          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">
            <h4>FIRMA - Posizione di stampa </h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 76.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_signature_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">
            <h4>AVALLANTE 1</h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 90.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_avallante_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>


        <div class="row mt-4">
          <div class="col-12">
            <h4>AVALLANTE 2</h4>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>
              Nota: <strong>Aumenta</strong> il valore per spostare in <strong>basso</strong> (predefinito 95.0 mm)
            </label>
            <label class="w-100">
              <i class="fas fa-info-circle"></i>Nota: Diminuisci il valore per spostare in <strong>alto</strong>
            </label>
            <div class="input-group mb-3">

              <input v-model="user_form.top_avallante_2_position" type="number" class="form-control">
              <div class="input-group-append">
                <span class="input-group-text">mm</span>
              </div>

            </div>
          </div>
        </div>


        <button type="submit" class="btn btn-lg btn-success btn-block" variant="primary"
                @click.prevent="modify()">Salva
        </button>
      </div>

      <!-- <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card> -->
      <br>
      <br>


    </div>

  </layout-with-sidebar>
</template>


<script>
import axios from "axios";

import LayoutWithSidebar from "@/components/layouts/LayoutWithSidebar";

import HeaderComponent from "../../components/HeaderComponent.vue";

export default {
  name: "MarginSettings", //this is the name of the component
  components: {
    LayoutWithSidebar: LayoutWithSidebar,
    HeaderComponent: HeaderComponent
  },
  data: function () {
    return {
      responseOk: false,
      errors: {},
      user: {},
      selected_template: 'centro_destra',
      user_form: {
        text_size: 3.6,
        text_size_signature: 3.6,
        top_date_place_position: 0,
        center_right_top: "",
        center_right_right: "",
        center_left_top: "",
        center_left_left: "",
        bottom_left_top: "",
        bottom_left_left: "",
        bottom_right_top: "",
        bottom_right_right: "",
        top_left_top: "",
        top_left_left: "",
        top_right_top: "",
        top_right_right: "",

        domiciliation_top_top_left: "",
        domiciliation_right_top_left: "",

        domiciliation_top_top_right: "",
        domiciliation_right_top_right: "",

        domiciliation_top_bottom_left: "",
        domiciliation_right_bottom_left: "",

        domiciliation_top_bottom_right: "",
        domiciliation_right_bottom_right: "",

        domiciliation_top_center_right: "",
        domiciliation_right_center_right: "",

        debtor_top_center_right: "",
        debtor_right_center_right: "",

        debtor_top_top_left: "",
        debtor_right_top_left: "",

        debtor_top_top_right: "",
        debtor_right_top_right: "",

        debtor_top_bottom_left: "",
        debtor_right_bottom_left: "",

        debtor_top_bottom_right: "",
        debtor_right_bottom_right: "",

        amount_top_top_left: "",
        amount_right_top_left: "",

        amount_top_top_right: "",
        amount_right_top_right: "",

        amount_top_bottom_left: "",
        amount_right_bottom_left: "",

        amount_top_bottom_right: "",
        amount_right_bottom_right: "",

        amount_top_center_right: "",
        amount_right_center_right: "",
        amortization_code_position: 'ALTO_SINISTRA',

        printer_brand: '',
        printer_model: '',

        top_beneficiary_position: '',
        top_amount_letter_position: '',
        top_amortization_type_position: '',
        right_amortization_type_position: '',

        top_expire_date_position: '',
        //   top_amount_position: '',
        // top_domiciliazione_position: '',
        //top_domiciliazione_cab_position: '',
        top_debtor_province_position: '',
        right_debtor_province_position: '',
        top_signature_position: '',
        top_avallante_position: '',
        top_avallante_2_position: '',
        right_cab_position: 0,

        amortization_date_issue: 'VISUALIZZA',
        amortization_expire_date: 'VISUALIZZA'
      },
      show: true
    };
  },
  mounted: function () {
    this.getUser();
  },
  computed: {},
  methods: {
    getUser: function () {
      var $vm = this;
      axios
          .get(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.loggedUser.id
          )
          .then(function (response) {
            $vm.user = response.data;

            $vm.user_form.text_size = ($vm.user.margin_settings.text_size) ? $vm.user.margin_settings.text_size : 3.6
            $vm.user_form.text_size_signature = ($vm.user.margin_settings.text_size_signature) ? $vm.user.margin_settings.text_size_signature : 3.6

            $vm.user_form.center_right_right = ($vm.user.margin_settings.center_right_right) ? $vm.user.margin_settings.center_right_right : 0
            $vm.user_form.center_right_top = ($vm.user.margin_settings.center_right_top) ? $vm.user.margin_settings.center_right_top : 53.5

            $vm.user_form.center_left_top = ($vm.user.margin_settings.center_left_top) ? $vm.user.margin_settings.center_left_top : 52.0
            $vm.user_form.center_left_left = ($vm.user.margin_settings.center_left_left) ? $vm.user.margin_settings.center_left_left : 0

            $vm.user_form.top_left_top = ($vm.user.margin_settings.top_left_top) ? $vm.user.margin_settings.top_left_top : 0
            $vm.user_form.top_left_left = ($vm.user.margin_settings.top_left_left) ? $vm.user.margin_settings.top_left_left : 0

            $vm.user_form.top_right_top = ($vm.user.margin_settings.top_right_top) ? $vm.user.margin_settings.top_right_top : 0
            $vm.user_form.top_right_right = ($vm.user.margin_settings.top_right_right) ? $vm.user.margin_settings.top_right_right : 0

            $vm.user_form.bottom_left_top = ($vm.user.margin_settings.bottom_left_top) ? $vm.user.margin_settings.bottom_left_top : 109.6
            $vm.user_form.bottom_left_left = ($vm.user.margin_settings.bottom_left_left) ? $vm.user.margin_settings.bottom_left_left : 0

            $vm.user_form.bottom_right_top = ($vm.user.margin_settings.bottom_right_top) ? $vm.user.margin_settings.bottom_right_top : 109.6
            $vm.user_form.bottom_right_right = ($vm.user.margin_settings.bottom_right_right) ? $vm.user.margin_settings.bottom_right_right : 0


            $vm.user_form.domiciliation_top_top_left = ($vm.user.margin_settings.domiciliation_top_top_left) ? $vm.user.margin_settings.domiciliation_top_top_left : 62
            $vm.user_form.domiciliation_right_top_left = ($vm.user.margin_settings.domiciliation_right_top_left) ? $vm.user.margin_settings.domiciliation_right_top_left : 0

            $vm.user_form.domiciliation_top_top_right = ($vm.user.margin_settings.domiciliation_top_top_right) ? $vm.user.margin_settings.domiciliation_top_top_right : 62
            $vm.user_form.domiciliation_right_top_right = ($vm.user.margin_settings.domiciliation_right_top_right) ? $vm.user.margin_settings.domiciliation_right_top_right : 0

            $vm.user_form.domiciliation_top_center_right = ($vm.user.margin_settings.domiciliation_top_center_right) ? $vm.user.margin_settings.domiciliation_top_center_right : 62
            $vm.user_form.domiciliation_right_center_right = ($vm.user.margin_settings.domiciliation_right_center_right) ? $vm.user.margin_settings.domiciliation_right_center_right : 0

            $vm.user_form.domiciliation_top_center_left = ($vm.user.margin_settings.domiciliation_top_center_left) ? $vm.user.margin_settings.domiciliation_top_center_left : 62
            $vm.user_form.domiciliation_right_center_left = ($vm.user.margin_settings.domiciliation_right_center_left) ? $vm.user.margin_settings.domiciliation_right_center_left : 0

            $vm.user_form.domiciliation_top_bottom_left = ($vm.user.margin_settings.domiciliation_top_bottom_left) ? $vm.user.margin_settings.domiciliation_top_bottom_left : 62
            $vm.user_form.domiciliation_right_bottom_left = ($vm.user.margin_settings.domiciliation_right_bottom_left) ? $vm.user.margin_settings.domiciliation_right_bottom_left : 0

            $vm.user_form.domiciliation_top_bottom_right = ($vm.user.margin_settings.domiciliation_top_bottom_right) ? $vm.user.margin_settings.domiciliation_top_bottom_right : 62
            $vm.user_form.domiciliation_right_bottom_right = ($vm.user.margin_settings.domiciliation_right_bottom_right) ? $vm.user.margin_settings.domiciliation_right_bottom_right : 0


            $vm.user_form.debtor_top_top_left = ($vm.user.margin_settings.debtor_top_top_left) ? $vm.user.margin_settings.debtor_top_top_left : 62
            $vm.user_form.debtor_right_top_left = ($vm.user.margin_settings.debtor_right_top_left) ? $vm.user.margin_settings.debtor_right_top_left : 80.6

            $vm.user_form.debtor_top_top_right = ($vm.user.margin_settings.debtor_top_top_right) ? $vm.user.margin_settings.debtor_top_top_right : 62
            $vm.user_form.debtor_right_top_right = ($vm.user.margin_settings.debtor_right_top_right) ? $vm.user.margin_settings.debtor_right_top_right : 80.6

            $vm.user_form.debtor_top_center_right = ($vm.user.margin_settings.debtor_top_center_right) ? $vm.user.margin_settings.debtor_top_center_right : 62
            $vm.user_form.debtor_right_center_right = ($vm.user.margin_settings.debtor_right_center_right) ? $vm.user.margin_settings.debtor_right_center_right : 80.6

            $vm.user_form.debtor_top_center_left = ($vm.user.margin_settings.debtor_top_center_left) ? $vm.user.margin_settings.debtor_top_center_left : 62
            $vm.user_form.debtor_right_center_left = ($vm.user.margin_settings.debtor_right_center_left) ? $vm.user.margin_settings.debtor_right_center_left : 80.6

            $vm.user_form.debtor_top_bottom_left = ($vm.user.margin_settings.debtor_top_bottom_left) ? $vm.user.margin_settings.debtor_top_bottom_left : 62
            $vm.user_form.debtor_right_bottom_left = ($vm.user.margin_settings.debtor_right_bottom_left) ? $vm.user.margin_settings.debtor_right_bottom_left : 80.6

            $vm.user_form.debtor_top_bottom_right = ($vm.user.margin_settings.debtor_top_bottom_right) ? $vm.user.margin_settings.debtor_top_bottom_right : 62
            $vm.user_form.debtor_right_bottom_right = ($vm.user.margin_settings.debtor_right_bottom_right) ? $vm.user.margin_settings.debtor_right_bottom_right : 80.6


            $vm.user_form.amount_top_top_left = ($vm.user.margin_settings.amount_top_top_left) ? $vm.user.margin_settings.amount_top_top_left : 11
            $vm.user_form.amount_right_top_left = ($vm.user.margin_settings.amount_right_top_left) ? $vm.user.margin_settings.amount_right_top_left : 179

            $vm.user_form.amount_top_top_right = ($vm.user.margin_settings.amount_top_top_right) ? $vm.user.margin_settings.amount_top_top_right : 11
            $vm.user_form.amount_right_top_right = ($vm.user.margin_settings.amount_right_top_right) ? $vm.user.margin_settings.amount_right_top_right : 179

            $vm.user_form.amount_top_center_right = ($vm.user.margin_settings.amount_top_center_right) ? $vm.user.margin_settings.amount_top_center_right : 11
            $vm.user_form.amount_right_center_right = ($vm.user.margin_settings.amount_right_center_right) ? $vm.user.margin_settings.amount_right_center_right : 179

            $vm.user_form.amount_top_center_left = ($vm.user.margin_settings.amount_top_center_left) ? $vm.user.margin_settings.amount_top_center_left : 11
            $vm.user_form.amount_right_center_left = ($vm.user.margin_settings.amount_right_center_left) ? $vm.user.margin_settings.amount_right_center_left : 179

            $vm.user_form.amount_top_bottom_left = ($vm.user.margin_settings.amount_top_bottom_left) ? $vm.user.margin_settings.amount_top_bottom_left : 11
            $vm.user_form.amount_right_bottom_left = ($vm.user.margin_settings.amount_right_bottom_left) ? $vm.user.margin_settings.amount_right_bottom_left : 179

            $vm.user_form.amount_top_bottom_right = ($vm.user.margin_settings.amount_top_bottom_right) ? $vm.user.margin_settings.amount_top_bottom_right : 11
            $vm.user_form.amount_right_bottom_right = ($vm.user.margin_settings.amount_right_bottom_right) ? $vm.user.margin_settings.amount_right_bottom_right : 179

            $vm.user_form.amortization_code_position = ($vm.user.margin_settings.amortization_code_position) ? $vm.user.margin_settings.amortization_code_position : 'ALTO_SINISTRA'

            $vm.user_form.top_date_place_position = ($vm.user.margin_settings.top_date_place_position) ? $vm.user.margin_settings.top_date_place_position : 0

            $vm.user_form.printer_brand = ($vm.user.margin_settings.printer_brand) ? $vm.user.margin_settings.printer_brand : ''
            $vm.user_form.printer_model = ($vm.user.margin_settings.printer_model) ? $vm.user.margin_settings.printer_model : ''

            $vm.user_form.top_beneficiary_position = ($vm.user.margin_settings.top_beneficiary_position) ? $vm.user.margin_settings.top_beneficiary_position : 38
            $vm.user_form.top_amount_letter_position = ($vm.user.margin_settings.top_amount_letter_position) ? $vm.user.margin_settings.top_amount_letter_position : 48
            $vm.user_form.top_amortization_type_position = ($vm.user.margin_settings.top_amortization_type_position) ? $vm.user.margin_settings.top_amortization_type_position : 23
            $vm.user_form.right_amortization_type_position = ($vm.user.margin_settings.right_amortization_type_position) ? $vm.user.margin_settings.right_amortization_type_position : 151.6

            $vm.user_form.top_expire_date_position = ($vm.user.margin_settings.top_expire_date_position) ? $vm.user.margin_settings.top_expire_date_position : 23
            //  $vm.user_form.top_amount_position = ($vm.user.margin_settings.top_amount_position) ? $vm.user.margin_settings.top_amount_position : ''
            //  $vm.user_form.top_domiciliazione_position = ($vm.user.margin_settings.top_domiciliazione_position) ? $vm.user.margin_settings.top_domiciliazione_position : ''
            //  $vm.user_form.top_domiciliazione_cab_position = ($vm.user.margin_settings.top_domiciliazione_cab_position) ? $vm.user.margin_settings.top_domiciliazione_cab_position : ''
            $vm.user_form.top_debtor_province_position = ($vm.user.margin_settings.top_debtor_province_position) ? $vm.user.margin_settings.top_debtor_province_position : 83
            $vm.user_form.right_debtor_province_position = ($vm.user.margin_settings.right_debtor_province_position) ? $vm.user.margin_settings.right_debtor_province_position : 83

            $vm.user_form.top_signature_position = ($vm.user.margin_settings.top_signature_position) ? $vm.user.margin_settings.top_signature_position : 76
            $vm.user_form.top_avallante_position = ($vm.user.margin_settings.top_avallante_position) ? $vm.user.margin_settings.top_avallante_position : 90
            $vm.user_form.top_avallante_2_position = ($vm.user.margin_settings.top_avallante_2_position) ? $vm.user.margin_settings.top_avallante_2_position : 95
            $vm.user_form.right_cab_position = ($vm.user.margin_settings.right_cab_position) ? $vm.user.margin_settings.right_cab_position : 0

            $vm.user_form.amortization_date_issue = ($vm.user.margin_settings.amortization_date_issue) ? $vm.user.margin_settings.amortization_date_issue : 'VISUALIZZA'
            $vm.user_form.amortization_expire_issue = ($vm.user.margin_settings.amortization_expire_issue) ? $vm.user.margin_settings.amortization_expire_issue : 'VISUALIZZA'

          });
    },
    modify: function () {
      var $vm = this;

      $vm.responseOk = false;
      var user = JSON.parse(JSON.stringify($vm.user_form));

      axios
          .patch(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.user.id + '/settings',
              user
          )
          .then(function (response) {
            $vm.responseOk = true;
            //$vm.$router.push({name: 'register-success'})
            //var loginData = {username: $vm.user.username, password: $vm.user.plainPassword}
            //axios.post(process.env.VUE_APP_API_BASE_URL+'/api/v1/login', loginData)
            //  .then(function (response) {
            //    $vm.$cookies.set('token', response.data.token)
            //    $vm.$cookies.set('user', response.data.user)
            //    $vm.$router.push({name: 'home'})
            //  })
            $vm.$toasted.show('Profilo salvato con successo!', {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 1300,
              type: 'success',
              class: 'toast'
            })


          })
          .catch(function (error) {
            $vm.errors = error.response.data;
          });
    }
  }
};
</script>

<style scoped>
.custom-centered {
  margin: 0 auto;
  width: 300px;
}

.text-color {
  color: white;
}

.ed-bg {
  background-color: #272f44;
  background-color: #222939;
}


.pricing-header {
  color: white;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

i.fas {
  font-size: 20px;
  float: left;
  margin-right: 10px;
  margin-top: -1px;
}
</style>
